export var EntitlementStatus;
(function (EntitlementStatus) {
    EntitlementStatus["Approved"] = "Approved";
    EntitlementStatus["Pending"] = "Pending";
    EntitlementStatus["Rejected"] = "Rejected";
})(EntitlementStatus || (EntitlementStatus = {}));
export var MarketDataEntitlementTypes;
(function (MarketDataEntitlementTypes) {
    MarketDataEntitlementTypes["Undefined"] = "Undefined";
    MarketDataEntitlementTypes["ProfessionalUser"] = "ProfessionalUser";
    MarketDataEntitlementTypes["NonProfessionalUser"] = "NonProfessionalUser";
    MarketDataEntitlementTypes["DelayedQuotesOnlyUser"] = "DelayedQuotesOnlyUser";
})(MarketDataEntitlementTypes || (MarketDataEntitlementTypes = {}));
export const AllMarketDataEntitlementTypes = [
    MarketDataEntitlementTypes.Undefined,
    MarketDataEntitlementTypes.ProfessionalUser,
    MarketDataEntitlementTypes.NonProfessionalUser,
    MarketDataEntitlementTypes.DelayedQuotesOnlyUser,
];
//# sourceMappingURL=Entitlements.js.map